"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteDetailsLayout = exports.SiteDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var main_aside_1 = require("../elements/main-aside");
var entity_list_section_1 = require("./entity-list-section");
var content_node_1 = require("./content-node");
var content_section_1 = require("../elements/content-section");
var entity_row_1 = require("./entity-row");
var lodash_1 = require("lodash");
var use_lang_1 = require("../../hooks/use-lang");
var grid_1 = require("../elements/grid");
var entity_link_value_1 = require("./entity-link-value");
var entity_contact_info_1 = require("./entity-contact-info");
var menu_context_1 = require("../context/menu-context");
var site_rebuild_dialog_1 = require("./site-rebuild-dialog");
var icons_1 = require("../icons");
var use_modal_1 = require("../../hooks/use-modal");
var entity_reverse_connect_controls_1 = require("../../v2/entities/entity-reverse-connect-controls");
var entity_reverse_list_section_1 = require("./entity-reverse-list-section");
exports.SiteDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentNodeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: 0;\n    }\n  "], ["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: 0;\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n  "])), ContentNodeStyles, theme_1.theme.UNIT(4))
});
var SummaryStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    font-size: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n    font-size: ", ";\n  "])), ContentNodeStyles, theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(16))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContactSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    &:first-child {\n      padding-top: ", ";\n    }\n  "], ["\n    padding-bottom: ", ";\n    &:first-child {\n      padding-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
var RowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-top: ", ";\n    width: 100%;\n    margin-bottom: ", ";\n    padding: ", " ", " ", " ", ";\n    ", ";\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    margin-top: ", ";\n    width: 100%;\n    margin-bottom: ", ";\n    padding: ", " ", " ", " ", ";\n    ", ";\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1), theme_1.theme.UNIT(1), theme_1.theme.UNIT(7.5), theme_1.theme.UNIT(1), theme_1.theme.H_DOT_BG_END())
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: -2px;\n    box-sizing: border-box;\n    opacity: 0.9;\n    padding: ", " 0 ", " ", "; \n    border: 1px dotted ", ";\n    background: #FCFCFC;\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: -2px;\n    box-sizing: border-box;\n    opacity: 0.9;\n    padding: ", " 0 ", " ", "; \n    border: 1px dotted ", ";\n    background: #FCFCFC;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(0, 2), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-mid'))
});
var ContactStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RebuildDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var OwnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var StandardPageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3))
});
var PropertiesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var ReverseConnectControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  ReverseListSection: (0, styled_components_1.default)(entity_reverse_list_section_1.EntityReverseListSection)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  RebuildDialog: (0, styled_components_1.default)(site_rebuild_dialog_1.SiteRebuildDialog)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), RebuildDialogStyles),
  ReverseConnectControls: (0, styled_components_1.default)(entity_reverse_connect_controls_1.EntityReverseConnectControls)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ReverseConnectControlsStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Summary: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), SummaryStyles),
  Row: (0, styled_components_1.default)(entity_row_1.EntityRow)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Owner: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), OwnerStyles),
  StandardPage: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), StandardPageStyles),
  Properties: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), PropertiesStyles),
  ContactSection: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ContactSectionStyles),
  Contact: (0, styled_components_1.default)(entity_contact_info_1.EntityContactInfo)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ContactStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
var SiteDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    banner = props.banner,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter;
  var _a = entity.pages,
    pages = _a === void 0 ? [] : _a,
    _b = entity.feedEntries,
    feedEntries = _b === void 0 ? [] : _b,
    _c = entity.organisations,
    organisations = _c === void 0 ? [] : _c,
    _d = entity.posts,
    posts = _d === void 0 ? [] : _d,
    _e = entity.economies,
    economies = _e === void 0 ? [] : _e,
    _f = entity.people,
    people = _f === void 0 ? [] : _f,
    _g = entity.events,
    events = _g === void 0 ? [] : _g,
    _h = entity.videos,
    videos = _h === void 0 ? [] : _h,
    description = entity.description,
    summary = entity.summary,
    twitter = entity.twitter,
    facebook = entity.facebook,
    flickr = entity.flickr,
    linkedin = entity.linkedin,
    tiktok = entity.tiktok,
    instagram = entity.instagram,
    youtube = entity.youtube,
    url = entity.url,
    owner = entity.owner,
    homePage = entity.homePage,
    knowledgeHubPage = entity.knowledgeHubPage,
    termsPage = entity.termsPage,
    privacyPolicyPage = entity.privacyPolicyPage;
  var hasSummary = summary && summary.text;
  var hasDescription = description && description.text;
  var hasOwner = !!owner;
  var hasContact = linkedin || twitter || facebook || url || instagram || youtube || tiktok || flickr;
  var hasAside = asideHeader || asideFooter || hasContact || hasOwner || !!termsPage || !!privacyPolicyPage || !!homePage || !!knowledgeHubPage;
  var modal = (0, use_modal_1.useModal)();
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(menu_context_1.MenuProvider, {
    value: {
      extraItems: [{
        label: t('Rebuild {{SITE}}...'),
        value: 'rebuild',
        icon: react_1.default.createElement(icons_1.Icons.ChevronUpCircle, null),
        onClick: function (event) {
          event.preventDefault();
          modal.show(react_1.default.createElement(My.RebuildDialog, {
            entity: entity
          }));
        }
      }]
    }
  }, react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(menu_context_1.MenuProvider, {
    value: {
      preventDelete: true
    }
  }, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, hasSummary && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Summary, {
      entity: summary,
      title: 'Summary:'
    })), hasDescription && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Description, {
      entity: description,
      title: 'About:'
    })), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Page"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: pages,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Post"],
      showMenu: true,
      showPublishDate: true,
      maxDescriptionWords: 40,
      items: (0, lodash_1.reverse)((0, lodash_1.sortBy)(posts, 'published')),
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["FeedEntry"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: feedEntries,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Event"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: events,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Video"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: videos,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Organisation"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: organisations,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Person"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: people,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Economy"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: economies,
      maxItems: 5
    }), react_1.default.createElement(My.ReverseListSection, {
      entity: entity,
      showDescription: true,
      entityTypeNames: ["Reflection"],
      showMenu: true,
      maxDescriptionWords: 40,
      items: (0, lodash_1.get)(entity, 'reflections', []),
      maxItems: 5
    }), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, hasContact && react_1.default.createElement(My.ContactSection, {
      title: "Web & Social:"
    }, react_1.default.createElement(My.Contact, {
      entity: entity
    })), react_1.default.createElement(My.Properties, null, hasOwner && react_1.default.createElement(My.Owner, {
      imageSize: 48,
      label: "{{SITE}} Owner",
      entity: owner
    }), homePage && react_1.default.createElement(My.StandardPage, {
      imageSize: 48,
      label: "Home {{PAGE}}",
      entity: homePage
    }), knowledgeHubPage && react_1.default.createElement(My.StandardPage, {
      imageSize: 48,
      label: "Knowledge Hub {{PAGE}}",
      entity: knowledgeHubPage
    }), privacyPolicyPage && react_1.default.createElement(My.StandardPage, {
      imageSize: 48,
      label: "Privacy Policy {{PAGE}}",
      entity: privacyPolicyPage
    }), termsPage && react_1.default.createElement(My.StandardPage, {
      imageSize: 48,
      label: "Terms & Conditions {{PAGE}}",
      entity: termsPage
    })), asideFooter)
  }))));
};
exports.SiteDetailsLayout = SiteDetailsLayout;
exports.SiteDetailsLayout.defaultProps = exports.SiteDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37;